import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";

export const ContentContainer = styled(ContentContainerBase)`
  padding-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-bottom: 40px;
  }
`;

export const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  align-items: center;
`;
